import React from 'react';
import OverviewSummary from '../components/overview/OverviewSummary';
import { useSelector } from 'react-redux';
import { transactionTabs } from '../helpers/constant';
import CreateTransactionSection from '../components/junocards/CreateTransactionSection';
import BalancesSection from '../components/overview/BalancesSection';
import { cryptoTransactions } from '../helpers/constant';
import SavedAddressSection from '../components/SavedAddressSection';
import StatementTable from '../components/statments/StatementTable';
import TransactionsHistoryTable from '../components/transactions/TransactionsHistoryTable';
import CryptoBalance from '../components/cryptoBalance/CryptoBalance';
import { useJunoCommonFunctions } from '../../client/Juno/helpers';

const CryptoDashboardPage = () => {
    const { useWindowWidth } = useJunoCommonFunctions();
    const windowWidth = useWindowWidth();

    const activeCurrencyPage = useSelector(state => state.juno.activeCurrencyPage);

    const { managedCurrencies, totalCryptoAmount, balancesCrypto } = useSelector(
        state => state.juno,
    );

    return (
        <div>
            <div className="bg-rootStyle-bg p-0 lg:!p-1 lg:h-[588px] lg:!pt-[1px]">
                <div className="flex w-full gap-1 h-full">
                    <div className="lg:w-[70%] w-full h-full">
                        <OverviewSummary
                            balancesData={balancesCrypto}
                            totalAmount={totalCryptoAmount}
                        />
                    </div>
                    <div className="w-0 hidden lg:w-[30%] lg:block">
                        <CreateTransactionSection
                            activeCurrencyPage={activeCurrencyPage}
                            tabs={transactionTabs}
                        />
                    </div>
                </div>
            </div>
            <BalancesSection
                managedCurrencies={managedCurrencies}
                balancesData={balancesCrypto}
                actionIcons={cryptoTransactions}
            />
            {windowWidth >= 1100 ? <CryptoBalance actionIcons={cryptoTransactions} /> : null}
            <SavedAddressSection isDashboard={true} />
            <TransactionsHistoryTable isDashboard={true} />
            <StatementTable isDashboardPage={true} activeCurrencyPage={activeCurrencyPage} />
        </div>
    );
};

export default CryptoDashboardPage;
